<template>
  <div class="position-relative">
    <router-link
      :to="{
        name: $routerNames.EDIT,
        params: {
          ...account.params,
          ...$route.params,
        },
      }"
    >
      <Icon name="settings-outline" :fill="$scss.colors.secondaryTextBg" />
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '@/components/atoms/Icon';

export default {
  name: 'AccountStatusBarActionsEditProfile',
  components: {
    Icon,
  },
  computed: {
    ...mapState('current', ['account']),
  },
};
</script>
